import { createSlice } from "@reduxjs/toolkit";

const ExploreSlice = createSlice({
    name: 'Explore',
    initialState: {
        dp1: "Community Solar",
        Type: "Commercial",
        Location: null,
        SolarFarm: "Community Solar",
        Month: "Community Solar",
        Year: "Community Solar",
        filteredData: [],
        selectedRowData: null,
    },
    reducers: {
        chgdp1: (state, action) => {
            state.dp1 = action.payload;
        },
        chgtype: (state, action) => {
            state.Type = action.payload;
        },
        chgLocation: (state, action) => {
            state.Location = action.payload;
        },
        chgSolarFarm: (state, action) => {
            state.SolarFarm = action.payload;
        },
        chgMonth: (state, action) => {
            state.Month = action.payload;
        },
        chgYear: (state, action) => {
            state.Year = action.payload;
        },
        setFilteredData: (state, action) => {
            state.filteredData = action.payload;
        },
        setSelectedRowData: (state, action) => {
            state.selectedRowData = action.payload;
        }
    }
});

export const { chgLocation, chgMonth, chgSolarFarm, chgYear, chgdp1, chgtype, setFilteredData, setSelectedRowData } = ExploreSlice.actions;
export default ExploreSlice.reducer;
